<template>
  <v-dialog
    v-model="dialog"
    width="500"
    persistent
  >
    <v-card>
      <v-alert
        type="warning"
      >
        Idle Session
      </v-alert>

      <v-card-text>
        Continue the session? {{ counter }}
      </v-card-text>

      <v-divider />
            
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="progressing"
          @click="logout"
        >
          Logout
        </v-btn>
        <v-btn
          color="primary"
          text
          :disabled="progressing"
          @click="continueSession"
        >
          Continue
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        progressing: false,
        sessionContinued: false,
        counter: null,
        timerId: '',
      }
    },
    watch: {
      // built-in computed from idle-vue
      isAppIdle: {
        immediate: true,
        handler (value) {
          if (value === true) {
            this.setDialog()
          }
        },
      },
    },
    beforeDestroy () {
      clearInterval(this.timerId)
    },
    methods: {
      setDialog () {
        this.dialog = true        
        this.counter = 20

        this.timerId = setInterval(() => { 
          this.counter -= 1

          if (this.counter === 0 && !this.sessionContinued) {
            // eslint-disable-next-line
            console.log('time up - logout')

            this.logout()
          }           

          if (this.sessionContinued) {
            this.sessionContinued = false
            this.counter = null

            clearInterval(this.timerId)            
          }
        }, 1000)
      },
      continueSession () {
        this.dialog = false
        this.sessionContinued = true
      }, 
      logout () {
        this.progressing = true
        
        this.$logout()
          .then(() => {
            this.progressing = false

            this.$router.push({ path: '/login' })
          })
      },
    },
  }
</script>
